import { Injectable, KeyValueDiffers, ViewContainerRef } from '@angular/core';
import { NgxDOMComponent, NgxDOMComponentContainer, NgxDOMComponentCreateOptions } from './ngx-dom-component.class';


@Injectable()
export class NgxDOMComponentService {

  constructor(differs: KeyValueDiffers) {
    NgxDOMComponent.differs = differs;
  }

  createContainer(viewContainerRef: ViewContainerRef): NgxDOMComponentContainer {
    return new NgxDOMComponentContainer(viewContainerRef);
  }

  createComponent(options: NgxDOMComponentCreateOptions): NgxDOMComponent {
    return new NgxDOMComponent(options);
  }
}
